import React from 'react'
import { useLanguage } from '../config/language/LanguageContext';
import phonewithbg from "./../assets/phonewithbg.png";
import { icons } from '../config/language/utils';

const Features = () => {
  const { locale } = useLanguage();

  return (
   <section className="py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <h2 className="text-3xl font-semibold text-gray-800 mb-12 text-left">
            {locale.FEATURES.heading}
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-8">
            <div className="space-y-8">
              {locale.FEATURES.lists.map((feature, index) => {
                const colors = [
                  "bg-blue-100",
                  "bg-purple-100",
                  "bg-pink-100",
                  "bg-yellow-100",
                  "bg-green-100",
                ];
                return (
                  <div
                    key={feature.title}
                    className="flex items-start space-x-4"
                  >
                    <div
                      className={`flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center ${colors[index]}`}
                    >
                      <img
                        src={icons[index]}
                        alt={feature.title}
                        className="h-6 w-6"
                      />
                    </div>
                    <div>
                      <h4 className="text-lg font-semibold text-gray-800">
                        {feature.title}
                      </h4>
                      <p className="text-gray-500 text-sm">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="bg-orange-500 rounded-2xl flex justify-center items-center overflow-hidden">
              <img
                src={phonewithbg}
                alt="App Screenshot"
                className="max-w-full h-auto object-cover object-center"
              />
            </div>
          </div>
        </div>
      </section>
  )
}

export default Features
